import { EMPTY } from "../constants/global";

function disableInput(input: HTMLInputElement | null, inputWrapper: HTMLElement | null) {
	if (input !== null) {
		input.disabled = true;
		input.readOnly = true;
		input.style.backgroundColor = "#dfdfdf";
		input.style.setProperty("border-color", "#cdcdcd", "important");
		input.value = EMPTY;
	}
	if (inputWrapper !== null) {
		inputWrapper.style.display = "none";
	}
}

export default disableInput;
